import React from 'react';
import { LayoutDashboard, Settings, Bell } from 'lucide-react';
export function Header() {
  return <header className="bg-white border-b border-slate-200 sticky top-0 z-10" data-id="element-102">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-103">
        <div className="flex justify-between h-16 items-center" data-id="element-104">
          <div className="flex items-center gap-2" data-id="element-105">
            <div className="bg-indigo-600 p-2 rounded-lg" data-id="element-106">
              <LayoutDashboard className="w-5 h-5 text-white" data-id="element-107" />
            </div>
            <span className="text-xl font-semibold text-slate-900 tracking-tight" data-id="element-108">
              LeadDistro{' '}
              <span className="text-slate-400 font-normal" data-id="element-109">Console</span>
            </span>
          </div>
          <div className="flex items-center gap-4" data-id="element-110">
            <button className="text-slate-400 hover:text-slate-600 transition-colors" data-id="element-111">
              <Bell className="w-5 h-5" data-id="element-112" />
            </button>
            <button className="text-slate-400 hover:text-slate-600 transition-colors" data-id="element-113">
              <Settings className="w-5 h-5" data-id="element-114" />
            </button>
            <div className="w-8 h-8 rounded-full bg-indigo-100 border border-indigo-200 flex items-center justify-center text-indigo-700 font-medium text-sm" data-id="element-115">
              JD
            </div>
          </div>
        </div>
      </div>
    </header>;
}